<template>
  <div>
    <span class="link" @click="toggleOpen">{{ equipment.name }}</span>
    <Modal
      v-if="open"
      title="Equipment Details"
      no-submit
      @hide-modal="toggleOpen"
    >
      <div>
        <EquipmentCard
          v-if="details"
          v-bind="details"
          :address="fullAddress(details.address)"
          :equipment-type-name="details.equipment_type_name"
          :service-history="details.service_history"
          :show-service-history="equipmentTypesEnabled"
          :default-collapsed="false"
          :components="activeComponents"
        >
          <template #componentsTable>
            <EquipmentComponentsTable :components="activeComponents" />
          </template>
          <template #serviceHistoryTable>
            <EquipmentServiceHistoryTable
              :service-history="details.service_history"
            />
          </template>
        </EquipmentCard>
        <Spinner v-else message="Loading equipment details..." />
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Modal from "@/components/Modal.vue";
import Spinner from "@/components/Spinner.vue";
import EquipmentComponentsTable from "@/ComponentTypes/EquipmentComponentsTable.vue";
import EquipmentServiceHistoryTable from "@/Equipment/EquipmentServiceHistoryTable.vue";
import { fullAddress } from "@/mixins";
export default {
  components: {
    Modal,
    Spinner,
    EquipmentComponentsTable,
    EquipmentServiceHistoryTable
  },
  props: {
    equipment: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      open: false,
      details: null
    };
  },
  computed: {
    ...mapState({
      equipmentTypesEnabled({ tenant }) {
        if (!tenant) return false;
        return Boolean(tenant.feature_flags.equipment_types);
      }
    }),
    activeComponents() {
      if (!this.details) return [];
      return (this.details.components || []).filter((comp) => !comp.archived);
    }
  },
  watch: {
    open(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.fetchDetails();
      }
    }
  },
  methods: {
    fullAddress,
    ...mapActions(["fetchEquipment"]),
    async fetchDetails() {
      this.details = await this.fetchEquipment({
        customerId: this.equipment.customer_id,
        equipmentId: this.equipment.id
      });
    },
    toggleOpen() {
      this.open = !this.open;
    }
  }
};
</script>

<style lang="scss" scoped></style>
